import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExtratoFinanceiroComponent } from './extrato-financeiro/extrato-financeiro.component';
import { PrestacaoContaComponent } from './prestacao-conta/prestacao-conta.component';

const routes: Routes = [
  {path: "financeiro/:id", component: ExtratoFinanceiroComponent},
  {path: "prestacao-conta/:idSocio", component: PrestacaoContaComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class FinanceiroRoutingModule { }
